import { render, staticRenderFns } from "./historicalSituationPieTwo.vue?vue&type=template&id=4a1d3652&scoped=true"
import script from "./historicalSituationPieTwo.vue?vue&type=script&lang=js"
export * from "./historicalSituationPieTwo.vue?vue&type=script&lang=js"
import style0 from "./historicalSituationPieTwo.vue?vue&type=style&index=0&id=4a1d3652&prod&lang=stylus&scoped=true"
import style1 from "./historicalSituationPieTwo.vue?vue&type=style&index=1&id=4a1d3652&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d3652",
  null
  
)

export default component.exports